var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex justify-between border-t border-primary-color leading-4",
    },
    [
      _c(
        "div",
        { staticClass: "flex items-center" },
        [
          _c(
            "div",
            { staticClass: "h-5 w-5 mr-2" },
            [_vm.completed ? _c("CheckedIcon") : _c("ReloadIcon")],
            1
          ),
          _c("CardItemTitle", {
            staticClass: "whitespace-no-wrap",
            attrs: { title: _vm.title },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.alertShown
            ? _c(
                "ActivityHoursUnconfirmedAlert",
                {
                  attrs: {
                    title:
                      "The project has one or more task with hours requested by a contractor, but working hours have not yet been approved",
                  },
                },
                [_c("AlertIcon", { staticClass: "block h-5 w-5" })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }